import { SupplierTypeInversed, SupplierTypeKeys } from '@teinor/erp/types/company/supplier'
import { useState } from 'react'
import { ModalCreateEditMedium } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { FormElement, FormRender, FormSection } from '../../../../../../../forms/FormRenderer/types'
import { ImageInputFile } from '../../../../../../../forms/ImageInput/types'
import { returnClassOfSpanTemplate } from '../../../../../../../utils/globals/tailwind'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

type ModalImportSuppliersProps = ModalEditComponentProps & ModalImportSuppliersLogicProps & {
    title: string
}


const ModalImportSuppliers: React.FC<ModalImportSuppliersProps> = ({ title, userPermissions, allRowData, typeSupplier, ...rest }) => {
    const { t } = useTwinTranslation()
    const { fields } = useModalImportCustomersLogic({typeSupplier})

    return (
        <ModalCreateEditMedium url='/api/app/supplier/importSuppliers' {...rest} fields={fields} translations={{
            title,
            button: t('create', 'Crear')
        }} haveButtonPermissions={true} imagePath={['tmp']} >
        </ModalCreateEditMedium>
    )
}
interface ModalImportSuppliersLogicProps {
    typeSupplier: SupplierTypeKeys
}
const useModalImportCustomersLogic = ({ typeSupplier }: ModalImportSuppliersLogicProps) => {
    const { t } = useTwinTranslation()
    const [file, setFile] = useState<ImageInputFile[]>([])

    const typeSupplierLabel = typeSupplier === SupplierTypeInversed['supplier'] ? t('posCodeSupplierColumn', 'Posición columna código proveedor') : t('posCodeCreditorColumn', 'Posición columna código acreedor')

    const csvFields: FormElement<any>[] = []
    const addressFields: FormSection<any>[] = []
    if (file.length) {
        csvFields.push(
            {
                name: 'delimiter',
                label: t('delimiter', 'Delimitado'),
                component: 'InputWithLabelMargin',
                defaultValue: ';',
                required: true,
            },
            {
                name: 'rowsToSkip',
                label: t('rowsToSkip', 'Filas que saltar'),
                component: 'InputWithLabelMarginIntegerStateFull',
                required: true
            },
            {
                name: 'posNameColumn',
                label: t('posNameColumn', 'Posición columna nombre'),
                component: 'InputWithLabelMarginIntegerStateFull',
                required: true
            },
            {
                name: 'posFiscalNameColumn',
                label: t('posFiscalNameColumn', 'Posición columna nombre fiscal'),
                component: 'InputWithLabelMarginIntegerStateFull',
                required: true
            },
            {
                name: 'posCodeColumn',
                label: typeSupplierLabel,
                component: 'InputWithLabelMarginIntegerStateFull',
            },
            {
                name: 'posIDNumberColumn',
                label: t('posIDNumberColumn', 'Posición columna DNI'),
                component: 'InputWithLabelMarginIntegerStateFull',
                required: true
            },
            {
                name: 'posPhoneColumn',
                label: t('posPhoneColumn', 'Posición columna teléfono'),
                component: 'InputWithLabelMarginIntegerStateFull',
            },
            {
                name: 'posMobileColumn',
                label: t('posMobileColumn', 'Posición columna móvil'),
                component: 'InputWithLabelMarginIntegerStateFull',
            },
            {
                name: 'posEmailColumn',
                label: t('posEmailColumn', 'Posición columna email'),
                component: 'InputWithLabelMarginIntegerStateFull',
            },
            {
                name: 'posLangColumn',
                label: t('posLangColumn', 'Posición columna idioma'),
                component: 'InputWithLabelMarginIntegerStateFull',
            },
        )
    }
    if(file.length){
        addressFields.push(
            {
                cols: 2,
                title: t('address', 'Dirección'),
                elements: [
                    {
                        name: 'posAddressColumn',
                        label: t('posAddressColumn', 'Posición columna dirección'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                    },
                    {
                        name: 'posAddressAdditionalColumn',
                        label: t('posAddressAdditionalColumn', 'Posición columna dirección adicional'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                    },
                    {
                        name: 'posPostalCodeColumn',
                        label: t('posPostalCodeColumn', 'Posición columna código postal'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                    },
                    {
                        name: 'posCityColumn',
                        label: t('posCityColumn', 'Posición columna ciudad'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                    },
                    {
                        name: 'posCountryColumn',
                        label: t('posCountryColumn', 'Posición columna país'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                        required: true
                    },
                    {
                        name: 'posStateCountryColumn',
                        label: t('posStateCountryColumn', 'Posición columna provincia'),
                        component: 'InputWithLabelMarginIntegerStateFull',
                    }
                ]
            }
        )
    }

    const fields: FormRender<any> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'type',
                    label: t('supplierType', 'Tipo de proveedor'),
                    component: 'InputHidden',
                    value: typeSupplier,
                },
                {
                    name: 'filePath',
                    component: 'FilesInput',
                    label: t('uploadExcelOrCSV', 'Subir excel o CSV'),
                    acceptFileConditions: {
                        'text': ['.csv', '.xlsx']
                    },
                    onChange: setFile,
                    className: returnClassOfSpanTemplate(2)
                },
                ...csvFields,
            ]
        },
        ...addressFields
    ]
    return { fields }
}


export default ModalImportSuppliers